"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ shouldStretchBoxes = false, blackThemeStyle = false, selected = false }) => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign({ minWidth: '80px', width: shouldStretchBoxes ? '100% !important' : 'max-content !important', cursor: 'pointer', border: 'solid 1px rgba(230, 230, 230, 1)', borderRadius: '7px', background: 'rgba(255, 255, 255, 1)' }, (selected && {
        background: blackThemeStyle ? 'rgba(0, 0, 0, 0.08)' : theme.palette.secondary.main,
        borderColor: blackThemeStyle ? theme.qlub.palette.black.main : theme.palette.primary.main,
    }));
    const tipBoxContainer = {
        minWidth: '62px',
        direction: 'ltr',
        margin: '0 auto',
        paddingLeft: 'auto',
        paddingRight: 'auto',
        paddingTop: 'auto',
        width: '100%',
        cursor: 'pointer',
    };
    const percentageValue = {
        fontSize: '12px',
        px: 0.5,
    };
    const customTipBox = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        height: '100%',
    };
    const tipSecondaryLabel = {
        pl: '.5rem',
    };
    const mostCommonStyle = {
        backgroundColor: '#242424 !important',
        font: 'inter',
        textAlign: 'center',
        fontWeight: 400,
        fontSize: '0.625rem',
        height: 'auto',
        '&.MuiChip-root': {
            color: 'white !important',
            borderStyle: 'solid',
            borderColor: 'white !important',
            borderWidth: '1px',
            borderRadius: '50px !important',
            minWidth: 'unset',
            width: 'max-content !important',
            maxWidth: 'unset',
        },
        '& .MuiChip-label': {
            display: 'block',
            whiteSpace: 'normal',
            paddingTop: '10px',
            textAlign: 'center',
            padding: '4px 6.5px',
        },
    };
    const selectedCustomBox = {
        background: theme.palette.secondary.main,
        borderRadius: 50,
        padding: '4px 1rem',
        color: theme.palette.primary.main,
        minHeight: '38px',
        display: 'flex',
        alignItems: 'center',
    };
    const customBox = {
        padding: '4px 1rem',
        minHeight: '38px',
        display: 'flex',
        alignItems: 'center',
    };
    const stack = {
        minWidth: 'max-content',
        width: shouldStretchBoxes ? '100% !important' : 'max-content !important',
        cursor: 'pointer',
    };
    const customTipUiV2AddIcon = {
        color: theme.palette.primary.main,
    };
    return {
        percentageValue,
        customTipBox,
        tipSecondaryLabel,
        mostCommonStyle,
        selectedCustomBox,
        customBox,
        tipBoxContainer,
        container,
        stack,
        customTipUiV2AddIcon,
    };
};
exports.default = useStyle;
